import React from 'react';
import { Hash, FileText, Wrench, Tag, LucideIcon } from 'lucide-react';

interface QuickAction {
  label: string;
  /** Query scaffold prefilled into the input on tap (the tech fills the blank). */
  scaffold: string;
  Icon: LucideIcon;
}

// HVAC-shaped entry points that seed a good first query and showcase the
// hybrid-search differentiator. Tapping a chip prefills the scaffold and focuses
// the input — it does NOT auto-send (every lookup needs a specific the tech types).
const ACTIONS: QuickAction[] = [
  { label: 'Look up an error code', scaffold: 'What does error code ___ mean?', Icon: Hash },
  { label: 'Find a manual', scaffold: 'Find the manual for ', Icon: FileText },
  { label: 'Troubleshoot a unit', scaffold: 'Help me troubleshoot ', Icon: Wrench },
  { label: 'Search by model #', scaffold: 'Search by model number ', Icon: Tag },
];

interface QuickActionChipsProps {
  onPick: (scaffold: string) => void;
  /** Disable all chips while a send/load is in flight. */
  disabled?: boolean;
}

const QuickActionChips: React.FC<QuickActionChipsProps> = ({ onPick, disabled = false }) => {
  return (
    <div className="grid grid-cols-2 gap-3">
      {ACTIONS.map(({ label, scaffold, Icon }) => (
        <button
          key={label}
          type="button"
          disabled={disabled}
          onClick={() => onPick(scaffold)}
          className="group flex min-w-0 items-center gap-2.5 rounded-2xl border border-air-navy/15 bg-white/60 px-4 py-3.5 text-left
                     shadow-sm transition-all
                     hover:border-air-navy/40 hover:bg-white hover:shadow active:scale-[0.98]
                     focus:outline-none focus-visible:ring-2 focus-visible:ring-air-navy/40
                     disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white/60 disabled:active:scale-100
                     dark:border-air-skytext/20 dark:bg-white/5 dark:hover:bg-white/10"
        >
          <Icon
            className="h-5 w-5 flex-shrink-0 text-air-navy transition-colors dark:text-air-skytext"
            strokeWidth={2}
          />
          <span className="min-w-0 break-words text-sm font-medium leading-tight text-air-navy dark:text-gray-100">
            {label}
          </span>
        </button>
      ))}
    </div>
  );
};

export default QuickActionChips;
